import React from "react";
import styled from "styled-components";
import { colors } from "../../theme/color";
import fonts from "../../theme/fonts";

const BodyContainer = styled.div`
  @media (max-width: 950px) {
    padding: 0px;
    margin: 0px;
  }
  padding: 20px;
`;

const SectionHeading = styled.h3`
  margin-bottom: 10px;
  color: ${colors.PURPLE};
`;

const Subheading = styled.h4<{ css?: string }>`
  margin-bottom: 5px;
  position: relative;
  padding-left: 20px;
  color: ${colors.PURPLE};
  display: flex;
  align-items: center;
  ${({ css }) => css || ""}
`;

const SectionContent = styled.p<{ hasSubheading: boolean; css?: string }>`
  text-align: left;
  margin-bottom: 0px;
  position: relative;
  color: ${colors.DARK_GRAY};
  font-size: 16px;
  font-weight: ${fonts.fontWeight.regular};
  ${({ hasSubheading }) => !hasSubheading && "margin-left: 20px;"}
  ${({ css }) => css || ""}
`;

const Bullet = styled.span<{ color: string; fontSize: string; css?: string }>`
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: ${colors.PURPLE};
  font-size: ${({ fontSize }) => fontSize};
  ${({ css }) => css || ""}
`;

const ContentBullet = styled.span<{ color: string; fontSize: string }>`
  position: absolute;
  left: -15px;
  top: 8.5px;
  transform: translateY(-50%);
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  background-color: ${colors.DARK_GRAY};
  font-size: ${({ fontSize }) => fontSize};
`;

interface BodyContentProps {
  heading: string;
  content: {
    type: string;
    value: string | string[];
    content?: any;
    heading?: string;
    subheading?: string;
  }[];
}

const BodyContent: React.FC<BodyContentProps> = ({ heading, content }) => {
  let hasSubheading = false;

  return (
    <BodyContainer>
      <SectionHeading>{heading}</SectionHeading>
      {content.map((item, index) => {
        if (item.type === "subsections") {
          return (
            <BodyContent
              key={index}
              heading={item.subheading || item.heading || ""}
              content={item.content}
            />
          );
        }
        const value = Array.isArray(item.value)
          ? item.value.join("")
          : item.value;
        if (item.type === "subheading" || item.type === "heading") {
          const css = item.type === "subheading" ? "left:20px" : "";
          hasSubheading = true;
          return (
            <Subheading css={css} key={index}>
              <Bullet color="black" fontSize="1rem" />
              <span dangerouslySetInnerHTML={{ __html: value }}></span>
            </Subheading>
          );
        } else {
          return (
            <SectionContent key={index} hasSubheading={hasSubheading}>
              {!hasSubheading && (
                <ContentBullet color="black" fontSize="0.5rem" />
              )}
              <span dangerouslySetInnerHTML={{ __html: value }}></span>
            </SectionContent>
          );
        }
      })}
    </BodyContainer>
  );
};

export default BodyContent;
